/* eslint-disable */
/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * DO NOT MODIFY IT BY HAND. Instead, modify endpoint definitions in backend,
 * * start backend to regenerate swagger.json, and run react-scripts-trackman codegen
 * * to regenerate this file.
 * *
 * * If you find errors in this file, do the following (in order):
 * * 1. Check Swagger configuration in backend (often SwaggerResponse is wrongly defined)
 * * 2. Check backend type and controller definitions
 * * 3. Check if the endpoint is properly defined in consumedEndpoints.json
 * * 4. Report the issue to react-scripts-trackman maintainers (mga@trackman.com)
 */

import { ReportItemDto } from '../types/CodegenDashboardTypes';
import { AxiosInstance } from 'axios';
import { Result } from '../types/CodegenResult';

export class DashboardService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getDashboardReports = async () => {
    const response = await this.axiosInstance.get<Result<ReportItemDto[]>>(`/api/v1/Dashboard/reports`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };
}

export default DashboardService;
